/**
 * V2 Media Section Configuration
 *
 * Maps V2 StepNode.content.featuredMedia paths.
 *
 * V2 type: FeaturedMedia
 * - kind: 'Image' | 'Video'
 * - content: { image: LocalizedImage } | { video: LocalizedClip }
 * - appearance: FeaturedMediaStyle
 *
 * Sprint: schema-v2-migration, Sprint 4
 */

export type V2MediaKind = 'Image' | 'Video';

export const V2_MEDIA_KIND_OPTIONS: Array<{ value: V2MediaKind; label: string }> = [
  { value: 'Image', label: 'Image' },
  { value: 'Video', label: 'Video' },
];

export const V2_DEFAULT_MEDIA_STRUCTURE = {
  kind: 'Image' as V2MediaKind,
  content: { image: { translations: {} } },
  appearance: {},
};

export const V2_DEFAULT_IMAGE_CONTENT = { image: { translations: {} } };
export const V2_DEFAULT_VIDEO_CONTENT = { video: { translations: {} } };
